import { Outlet } from 'react-router';

import { useSafeParams } from 'hooks';

import { Footer } from '../footer';
import { ErrorMessage } from '../utils';

import { ReactComponent as LogoImg } from 'assets/images/brand-img.svg';

import styles from './styles.module.scss';

export const Registration = () => {
	const { token } = useSafeParams();

	return (
		<div className={styles.layoutWrapper}>
			<section className={styles.reg}>
				{!token && <ErrorMessage />}

				<Outlet />

				<div className={styles.reg__image}>
					<LogoImg />
				</div>
			</section>

			<Footer />
		</div>
	);
};
